/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();
import Global from './global';
import lottieWeb from 'lottie-web';
import CardKnox from './cardnox';

let cartIds = Global.functions.readCookie('inCartLater');
if (!cartIds) {
	cartIds = [];
}
'use strict';
const Cart = {
	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */

	$addToCart: $('.addToCart'),
	$removeFromlater: $('.removeFromlater'),
	//$removeFromCheckout: $('.js-remove-checkout'),
	//$addFromCheckout: $('.js-add-checkout'),
	//$flag: false,
	//$iflag: 0,
	//$iqty: 0,
	CartUpdateBtnTimeout: null,

	init: function() {
		this.emptyCart();
		this.showHideCoupon();
		this.addForLaterEach();
		//this.removeCheckout();
		//this.addCheckout();
		this.equalTitle();
		this.onKeyPress();
		this.cartCheckoutLoader();
		this.couponKeyUp();
		this.rotatingText();

		if ($('.cart_totals').length) {
			$(document).scroll(function() {
				if ((screen.width > 819)) {
					Cart.stickyCartTotals();
				}
			});
		}


		if ($('.woocommerce-cart').length) {
			if ($('.cart_totals ').length) {
				$('.products-slider__wrapper').removeClass('products-slider__wrapper--without-product');
			} else {
				$('.products-slider__wrapper').addClass('products-slider__wrapper--without-product');
			}
		}

		//after ajax
		$(document.body).on('updated_wc_div', function() {
			Cart.showHideCoupon();
			Cart.countCart();
			Cart.addForLaterEach();
			Cart.onKeyPress();
			Cart.couponKeyUp();
			$('body').removeClass('cart-overlay');
			$('.woocommerce').find('.js-cart-input').on('keyup', Cart.updateValue);
			$('.woocommerce').find('.js-later-input').on('keyup', Cart.updateValue);
		});

		$('.woocommerce').on('DOMNodeInserted', function(e) {
			if ($(e.target).is('.woocommerce-NoticeGroup')) {
				$('body').removeClass('cart-overlay');
			}
		});

		$('.woocommerce-btn-custom').on('click', function() {
			$('.place-order').find('button').trigger('click');
            $('body').toggleClass('cart-overlay', true);
		});

		/* Lottie animation for the checkout */
		let animation;
		let progressBar = $('.js-prediction-progress-bar span');
		let durationTime = parseInt(progressBar.data('prediction'));

		if($('body.woocommerce-checkout').length > 0) {
			console.log('Lottie Loaded');
			const animContainer = document.getElementById('estimated-time__animation-box');
	
			if (animContainer) {
				animation = lottieWeb.loadAnimation({
					container: animContainer,
					renderer: 'svg',
					path: '../wp-content/themes/fws-kadra/src/assets/animations/Checkout.json',
					loop: true,
					autoplay: false,
					rendererSettings: {
						progressiveLoad: true, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
					},
				});
			}
		}

		// showing the checkout popup for estimated time
		$('body').on('click', '#place_order', function(e) {
            $('body').toggleClass('cart-overlay', true);
            $('.estimated-time__popup').toggleClass('estimated-time__popup--show', true);
			animation.play();//play lottie animation

            //Animate the bar from 0 to 100%
            progressBar.width(0);
            progressBar.animate({
                width: '100%'
            }, {
                easing: 'linear',
                duration: durationTime * 1000,
            });
		});

        // hide popup on woocommerce checkout error
        $('body').on('checkout_error', function() {
            $('body').toggleClass('cart-overlay', false);
            $('.estimated-time__popup').toggleClass('estimated-time__popup--show', false);
			animation.stop();//stop lottie animation
        });

		jQuery(document).ready(function($) {
            const bodyObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1 && $(node).is('.wc-cardknox-error')) {

							setTimeout(() => {
								CardKnox.inputStyling();
								$('body').toggleClass('cart-overlay', false);
								$('.estimated-time__popup').toggleClass('estimated-time__popup--show', false);
								animation.stop();
								progressBar.stop(true, true);
								progressBar.width(0);

								$('html, body').animate({
									scrollTop: $('.woocommerce-checkout-payment').offset().top - 150
								}, 500);
							}, 1000);
                        }
                    });
                });
            });
            bodyObserver.observe(document.body, {childList: true, subtree: true});
        });

		$('.restore-item').on('click', function() {
			window.location.href = kadraGlobal.Url + '/cart';
		});

		$('body').on('click', '.js-cart-later-remove', function() { // delegated handling
			const id = $(this).closest('.cart__items-item').data('id');
			Cart.prepareAjax('GET', kadraGlobal.baseUrl + 'remove_from_later?id=' + id, {}, true);
			$(this).closest('.cart__items-item').remove();
			$('.cart-collaterals').toggle($('.cart-collaterals .cart__items-item').length > 0);
			Cart.refreshCart();
		});

		$('body').on('click', '.card-items-later-custom .js-cart-later-add', function() { // delegated handling
			const $row = $(this).closest('.cart__items-item');
			const id = $row.data('id');
			// eslint-disable-next-line camelcase
			const case_pack = 1; //$row.data('case_pack');
			const cases = $row.find('input').val();
			$row.remove();
			$('.cart-collaterals').toggle($('.cart-collaterals .cart__items-item').length > 0);
			// eslint-disable-next-line camelcase
			Cart.prepareAjax('GET', kadraGlobal.baseUrl + 'add_to_cart?id=' + id + '&pack=' + (cases * case_pack), {}, true);
			Cart.prepareAjax('GET', kadraGlobal.baseUrl + 'remove_from_later?id=' + id, {}, true);
		});

		$('body').on('keyup', '.card-items-later-custom input', function() {
			const CurrValue = parseInt($(this).val());
			if (isNaN(CurrValue)) {
				$(this).val($(this).data('old-value') || 0);
				return;
			}
			const NewValue = Math.max(1, Math.abs(CurrValue));
			$(this).val(NewValue);
			$(this).data('old-value', NewValue);
		});
        let timeout = null;
		$('body').on('click', '.js-product-quantity__button', function() {
            // get target input
            const input = $(this).parent().find('.input-text.qty.text');

            // handling "items saved for later"
            if (input.length === 0) {
                const Input = $(this).parent().find('input');
                const Additive = $(this).hasClass('js-product-quantity__minus') ? -1 : 1;
                const CurrValue = parseInt(Input.val());
                const NewValue = isNaN(CurrValue) ? 1 : Math.max(1, CurrValue + Additive);
                Input.val(NewValue);
                return; // nothing more to update
            }

            const packinput = $(this).parent().find('.pack');
            const pack = 1; //packinput.data('pack');
            const qty = isNaN(parseInt(packinput.val())) ? 0 : parseInt(packinput.val());
            const productId = input.closest('.cart_item').data('id');

            // detect if is decrement or increment
            if ($(this).hasClass('js-product-quantity__minus')) {

                if (qty <= 1) {
                    // remove from cart
                    const href = $(this).parents('.cart__items-item-right').find('.remove').attr('href');
                    window.location.href = href;
                    $('body').not('.single-product').addClass('cart-overlay');
                    if ($('.compare').length) {
                        $('body').removeClass('cart-overlay');
                    }
                    return false;
                } else {
                    //decrement input value
                    const sum = Math.max(1, qty - 1);
                    input.val(sum * pack);
                    packinput.val(sum);

                    clearTimeout(timeout);
                    timeout = setTimeout(function() {
                        $('body').not('.single-product').addClass('cart-overlay');
                        Cart.updateYouMayAlsoLike({id: productId, qty: sum});
                    }, 1000);
                    if ($('.compare').length) {
                        $('body').removeClass('cart-overlay');
                    }
                }
                const idIndex = cartIds.indexOf(productId);
                cartIds.splice(idIndex, 1);
                Global.functions.setCookie('inCartLater', cartIds);
            } else if ($(this).hasClass('js-product-quantity__plus')) {
                // increment input value
                const sum = Math.max(0, qty) + 1;
                input.val(sum * pack);
                packinput.val(sum);

                clearTimeout(timeout);
                timeout = setTimeout(function() {
                    $('body').not('.single-product').addClass('cart-overlay');
                    Cart.updateYouMayAlsoLike({id: productId, qty: sum});
                    cartIds.push(productId);
                    Global.functions.setCookie('inCartLater', cartIds);
                } , 1000);
                if ($('.compare').length) {
                    $('body').removeClass('cart-overlay');
                }
            }

            // get update cart button
            const updateBtn = $('[name="update_cart"]');

            // if button exist(cart page)
            if (updateBtn.length) {
                // remove disabled att from button so we can trigger button
                clearTimeout(Cart.CartUpdateBtnTimeout);
                Cart.CartUpdateBtnTimeout = setTimeout(function() {
                    updateBtn.removeAttr('disabled');
                    updateBtn.trigger('click');
                    $('body').not('.single-product').addClass('cart-overlay');
                    if ($('.compare').length) {
                        $('body').removeClass('cart-overlay');
                    }
                }, 1000);
            }
        });
	},

	rotatingText: function() {
		var texts = new Array();
		texts.push('Your order is processing...⏱️');
		texts.push('Fast-tracking your order to you... 🚀');
		texts.push('Securing the best prices for your selection... 💰');
		texts.push('Ensuring top-notch quality for your customers... 👌');
		texts.push('Preparing your order with exceptional care... 💼');
		
		var point = 0;

		function changeText(){
		$('.js-rotating-text').html(texts[point]);
		if(point < texts.length - 1){
			point ++;
		}else{
			point = 0;
		}
		setTimeout(changeText, 3000)
		}
		changeText();
	},

	couponKeyUp: function() {
		if ($('.js-input-text-coupon').length > 0) {
			$('.js-input-text-coupon').on('keyup', function() {
				$('#coupon_code').val($(this).val());
			});
		}

		$('.js-fake-coupon-btn').on('click', function(e) {
			e.preventDefault();
			$('button[name="apply_coupon"]').trigger('click');
		})
	},

	emptyCart: function() {
		$('body').on('click', '.js-empty-cart', function() {
			const url = kadraGlobal.baseUrl + 'empty_cart';
			Cart.prepareAjax('GET', url, {}, true);
			Cart.updateYouMayAlsoLike(null);
		});
	},

	onKeyPress: function() {
		$('.js-select-all-cart').find('input:first').on('keyup', function(e) {
			if(e.keycode == 13) {
				alert('radii');
			}
			const _thisVal = $(this).val();
			const _thisRemove = $(this).parent().parent().parent().parent().find('a.remove:first');
			const val = Math.max(0, parseInt($(this).val(), 10) || 0);
			$(this).val(val);
			const pack = 1; //Math.max(0, parseInt($(this).attr('data-pack'), 10));
			const input = $(this).parent().find('input:last');
			$(input).val(isNaN(val) ? pack : Math.abs(val) * pack);
			clearTimeout(Cart.CartUpdateBtnTimeout);
			Cart.CartUpdateBtnTimeout = setTimeout(function() {
				const updateBtn = $('[name="update_cart"]');
				if (!updateBtn) {
					return;
				}


				if ($('.compare').length) {
					$('body').removeClass('cart-overlay');
				}

				if (parseInt(_thisVal) > 0) {
					$('body').not('.single-product').addClass('cart-overlay');
					updateBtn.prop('disabled', false).trigger('click');
				}

				if (parseInt(_thisVal) < 1) {
					$('body').not('.single-product').addClass('cart-overlay');
					_thisRemove[0].click();
				}

				Cart.updateYouMayAlsoLike({id: input.closest('.cart_item').data('id'), qty: val});
			}, 1000);
		});
	},

	plusMinusFunctionality: function() {
        //asdassdasdasssd
	},

	updateYouMayAlsoLike(pack) {
		if (pack === null) { // clear cart
			window.VueProductSlider.$store.commit('SET_CART_DATA', {});
		} else {
			window.VueProductSlider.$store.commit('TO_CART', {id: pack.id, val: pack.qty});
		}
	},

	showHideCoupon: function() {

		$('.coupon-cart-custom-link').on('click', function() {
			$(this).addClass('coupon-cart-custom-link--deactive');
			$('.coupon-cart-custom-inner').addClass('coupon-cart-custom-inner--active');
			$('.coupon-cart-custom-inner .js-input-text-coupon').focus();
		});

		$('.coupon-cart-custom-close').on('click', function() {
			$('.coupon-cart-custom-inner').removeClass('coupon-cart-custom-inner--active');
			$('.coupon-cart-custom-link').removeClass('coupon-cart-custom-link--deactive');
		});
	},

	stickyCartTotals: function() {
		const Totals = $('.cart_totals');
		if (Totals.length === 0) {
			return;
		}
		if (Totals.offset().top + Totals.height() > $('.site-footer').offset().top - 10) {
			Totals.css({'position': 'absolute', 'box-shadow': 'none'});
		}
		if ($(document).scrollTop() + window.innerHeight < $('.site-footer').offset().top) {
			Totals.css({'position': 'fixed', 'box-shadow': '0 -5px 5px -7px #333'});
		}
	},

	addForLaterEach: function() {
		$('.js-add-for-later').each(function() {
			$(this).on('click', function() {
				const productId = $(this).attr('data-id');
				const qty = $(this).closest('.cart_item').find('input.pack').val();
				Cart.addForLater(productId, qty);
				$(this).remove();
			});
		});
	},

	addForLater: function(productId, qty) {
		$('body').addClass('cart-overlay');
		const url = kadraGlobal.baseUrl + 'add_to_later';
		const data = {
			'listId': 'later',
			'product_id': productId,
			'qty': qty,
		};
		Cart.prepareAjax('POST', url, data, false);
		Cart.cloneForLater(productId, qty);
	},

	cloneForLater: function(id, qty) {
		const clone = $('#' + id + '-product').clone(true, true);
		const pack = 1; //$(clone).find('input:first').attr('data-pack');
		$(clone).attr('id', '');
		$(clone).data('case_pack', pack);
		$(clone).find('.product-subtotal').remove();
		$(clone).find('.cart__items-item-quantity-wrapper').removeClass('product-quantity');
		if (cartIds.indexOf(id) >= 0) {
			$(clone).find('.cart__items-item-quantity-wrapper').html('<span class="cart__items-item-quantity-title">Quantity</span><div class="cart__items-item-quantity-contaner">'
				+ '<span>This product is already in cart</span>'
				+ '</div>');

			$(clone).find('.cart__items-item-title-remove').html('<a class="remove js-cart-later-remove" href="javascript:;">Remove</a>'
				+ '<span class="remove disabled">Already in cart</span>');
		} else {
			$(clone).find('.cart__items-item-quantity-wrapper').html('<span class="cart__items-item-quantity-title">Quantity</span><div class="cart__items-item-quantity-contaner">'
				+ '<span class="cart__items-item-quantity-toggle cart__items-item-quantity--minus js-product-quantity__minus js-product-quantity__button"></span>'
				+ '<input type="text" value="' + qty + ' " maxlength="5">'
				+ '<span class="cart__items-item-quantity-toggle cart__items-item-quantity--plus js-product-quantity__plus js-product-quantity__button"></span>'
				+ '</div>');
		}

		$(clone).find('.cart__items-item-title-remove').remove();

		if (window.innerWidth > 692) {
			$(clone).find('.cart__items-item-title-wrapper').append('<div class="cart__items-item-title-remove"><a href="javascript:;" class="remove js-cart-later-remove">Remove</a><a href="javascript:;" class="remove js-cart-later-add">Move back to cart</a></div>');
		} else {
			$(clone).find('.cart__items-item-title-wrapper').append('<div class="cart__items-item-title-remove"><a href="javascript:;" class="remove js-cart-later-remove">Remove</a></div>');
			$(clone).find('.cart__items-item-title-wrapper').append('<div class="cart__items-item-title-remove cart__items-item-title-remove--later"><a href="javascript:;" class="remove js-cart-later-add">Move back to cart</a></div>');
		}

		$('#' + id + '-product').find('input:first').val(0);
		$('#' + id + '-product').find('input:last').val(0);
		$('.card-items-later-custom .row').append(clone);
		$('.cart-collaterals').show();

		//Cart.addToCartAndRefresh();
		Cart.refreshCart();
	},

	refreshCart: function() {
		$('body').not('.single-product').addClass('cart-overlay');
		if ($('.compare, .post-type-archive-product').length) {
			$('body').removeClass('cart-overlay');
		}
		const Button = $('[name="update_cart"]');
		// empty cart has no button so we must reload page
		if (!Button.length && document.location.href.split('?')[0] === kadraGlobal.Url + '/cart/') {
			Cart.$flag = true;
			window.location.href = kadraGlobal.Url + '/cart';
			return;
		}
		Button.prop('disabled', false);
		Button.trigger('click');
	},

	updateValue: (event) => {
		let val = event.target.value;
		const max = 5;

		if (val.length > max) {
			val = val.slice(0, max);
			event.target.value = val;
		}
	},

	countCart: function() {
		let total = 0;
		$('.qty').each(function() {
			total += parseInt($(this).val());
		});
		$('#cartId').html(total);

		if (total > 99) {
			$('#cartId').addClass('bigger');
		} else {
			$('#cartId').removeClass('bigger');
		}
	},

	/*refreshCheckout: function() {
		$('body').not('.single-product').addClass('cart-overlay');
		if ($('.compare').length) {
			$('body').removeClass('cart-overlay');
		}
		$('body').trigger('update_checkout');
		$('.input-' + Cart.iflag).val(Cart.iqty);
		$('.qty-' + Cart.iflag).text(Cart.iqty);
		let total = 0;
		$('.product-info-box__total-quantity-contaner input').each(function() {
			total += parseInt($(this).val());
		});
		$('#cartId').html(total)
		console.log('refreshCheckout', total);;

		if (total > 99) {
			$('#cartId').addClass('bigger');
		} else {
			$('#cartId').removeClass('bigger');
		}

		if (Cart.iqty === 0) {
			$('.input-' + Cart.iflag).parent().parent().parent().remove();
			return false;
		}
	},*/

	/*removeCheckout: function() {
		Cart.$removeFromCheckout.each(function() {
			$(this).on('click', function() {
				const productId = $(this).attr('data-id');
				Cart.iflag = $(this).attr('data-key');
				const inputVal = $('.input-' + Cart.iflag).val();
				Cart.iqty = parseInt(inputVal) - 1;
				const url = kadraGlobal.baseUrl + 'remove_from_cart?id=' + productId;
				Cart.prepareAjax('GET', url, {}, true);
			});
		});
	},

	addCheckout: function() {
		Cart.$addFromCheckout.each(function() {
			$(this).on('click', function() {
				const productId = $(this).attr('data-id');
				Cart.iflag = $(this).attr('data-key');
				const inputVal = $('.input-' + Cart.iflag).val();
				Cart.iqty = parseInt(inputVal) + 1;
				const url = kadraGlobal.baseUrl + 'add_to_cart?id=' + productId;
				Cart.prepareAjax('GET', url, {}, true);
			});
		});
	},*/

	prepareAjax: function(type, url, data, refresh) {
		$('body').addClass('cart-overlay');
		Cart.$flag = true;
		$.ajax({
			url: url,
			type: type,
			data: data,
			success: function() {
				Cart.$flag = false;
				if (refresh) {
					Cart.refreshCart();
					//Cart.refreshCheckout();
				}
			},
			error: function() {
				if (refresh) {
					Cart.refreshCart();
					//Cart.refreshCheckout();
				}
			}
		});
	},

	equalTitle: function() {
	},

	// try to update qty in cart table, if exist
	updateCartTableRowQty: function(id, packs) {
		const TableRow = $('.cart_item[data-id=' + id + ']');
		if (TableRow) {
			const CaseInput = TableRow.find('.js-cart-input');
			const QtyInput = TableRow.find('.hidden-input');
			const PackSize = 1; //parseInt(CaseInput.data('pack'));
			QtyInput.val(packs * PackSize);
			CaseInput.val(packs);
		}
	},

	cartCheckoutLoader: function() {
		$('.checkout-button').on('click', function() {
			$('.checkout-button__wrap-loader').show();
		});
	},

};

export default Cart;
